
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import MarketModal from './components/MarketModal.vue';
import ShopService from '@/services/shop.service';
import { City } from '@/common/interface/shop';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    MarketModal,
  },
})
export default class CarMarket extends Vue {
  @lazyInject(CarService)
  carService!: CarService;

  @Ref('marketModal')
  marketModal!: MarketModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  AuthEnum = AuthEnum;

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showSizeChanger: true,
    onChange: this.paginationChange,
    onShowSizeChange: this.paginationSizeChange,
  };

  columns = [
    {
      title: '市场名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: 80,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 80,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 80,
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      width: 80,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 80,
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];

  citys: City[] = [];

  form: any = {
    marketName: '',
    marketPoi: '',
    cityCode: undefined,
  };

  @Watch('$route')
  handleSearch() {
    const { page, pageSize, marketName, marketPoi, cityCode } =
      this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (marketName) {
      params.marketName = marketName;
      this.form.marketName = marketName;
    }
    if (marketPoi) {
      params.marketPoi = marketPoi;
      this.form.marketPoi = marketPoi;
    }
    if (cityCode) {
      params.cityCode = cityCode;
      this.form.cityCode = +cityCode;
    }
    this.getShopMarketList(params);
  }

  paginationChange(page: number) {
    // this.pageChange(page);
    this.pagination.current = page;
    this.handleParams();
  }

  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  handleParams() {
    const { marketName, marketPoi, cityCode } = this.form;
    const { pageSize, current } = this.pagination;
    const query: any = {
      page: current || 1,
      pageSize: pageSize || 10,
      timestamp: `${Math.round(Date.now() / 1000)}`,
    };
    if (marketName) {
      query.marketName = marketName;
    }
    if (marketPoi) {
      query.marketPoi = marketPoi;
    }
    if (cityCode) {
      query.cityCode = cityCode;
    }
    this.$router.push({
      query,
    });
  }

  paginationSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.handleParams();
  }

  search() {
    this.pagination.current = 1;
    this.handleParams();
  }

  reset() {
    this.form = {
      marketName: '',
      marketPoi: '',
      cityCode: undefined,
    };
    this.pagination.current = 1;
    this.handleParams();
  }

  addMarket(type: string) {
    this.marketModal.init(type);
  }

  editMarket(type: string, data: any) {
    this.marketModal.init(type, data);
  }

  delMarket(data: any) {
    this.$confirm({
      title: '提示',
      content: `确定要删除市场【${data.name}】吗？`,
      onOk: async () => {
        const fromData = { is_del: 1, market_id: data.market_id };
        const res = await this.carService.carShopMarketEdit(fromData);
        if (res) {
          this.$message.success('操作成功');
          this.handleSearch();
        }
      },
      onCancel() {},
    });
  }

  async getShopMarketList(params: any) {
    const res = await this.carService.getCarShopMarketList(params, this.$el);
    this.data = res.list;
    this.pagination.total = res.total;
    console.log(res);
  }

  pageChange(page: number) {
    this.pagination.current = page;
    // this.getShopMarketList();
  }

  mounted() {
    this.handleSearch();
    this.getCityList();
  }

  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }
}
